// test1564
(1564 && 0);
